import { render, staticRenderFns } from "./Articles.Dialog.vue?vue&type=template&id=d375e532&scoped=true&"
import script from "./Articles.Dialog.vue?vue&type=script&lang=js&"
export * from "./Articles.Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Articles.Dialog.vue?vue&type=style&index=0&id=d375e532&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d375e532",
  null
  
)

export default component.exports